const SYMBOL_REPLACEMENTS = {
  '₮': 't',
  '+': 'plus',
} as const

export const getOverwrittenTokenSymbol = (symbol: string) => {
  let result = symbol
  for (const [weird, normal] of Object.entries(SYMBOL_REPLACEMENTS)) {
    result = result.replaceAll(weird.toLowerCase(), normal.toLowerCase())
  }
  return result
}
